<template>
  <div class="quiz_result">
    <div class="quiz_result_bg"></div>
    <div class="quiz_result_correct">
      <div class="quiz_result_correct_content">
        <div class="quiz_result_correct_content_image"></div>
        <div class="quiz_correct_point_area">
          <p><span>{{headerText}}</span></p>
        </div>
        <div class="quiz_explain">
          <figure class="quiz_image">
            <quiz-answer-image :qm_id="qm_id"/>
          </figure>
          <quiz-question>
            <quiz-text :text=correct_text />
            <div class="quiz_answer">
              <span>{{selection}}</span>
            </div>
          </quiz-question>
          <quiz-button :hint_url="hint_url" text="くわしく見る" @clickQuizButton="clickQuizButtonHandler(qm_id)"/>
          <quiz-close-button @closeClick="closeClickHandler" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuizQuestion from '@/components/QuizQuestion'
import QuizText from '@/components/QuizText'
import QuizButton from '@/components/QuizButton'
import QuizCloseButton from '@/components/QuizCloseButton'
import HintClickable from '@/components/mixins/HintClickable'
import QuizAnswerImage from '@/components/QuizAnswerImage'
export default {
  name: 'QuizResultCorrectDialog',
  mixins: [HintClickable],
  components: {
    QuizAnswerImage,
    QuizCloseButton,
    QuizButton,
    QuizText,
    QuizQuestion
  },
  props: {
    qm_id: {
      type: Number,
      required: true
    },
    point: {
      type: Number,
      required: true
    },
    correct_text: {
      type: String,
      required: true
    },
    selection: {
      type: String,
      required: true
    },
    hint_url: {
      type: String,
      required: true
    }
  },
  computed: {
    headerText () {
      return `${this.point} pt GET!`
    }
  },
  methods: {
    closeClickHandler () {
      this.$emit('closeClick')
    }
  }
}
</script>

<style scoped>
  .quiz_result_correct {
    background: #ec8dae;
    position: relative;
    padding: 10px 10px 51px;
    border-radius: 48px 0 48px 0;
    width: 880px;
    min-width: 880px;
  }

  @media screen and (max-width: 767px) {
    .quiz_result_correct {
      margin: 0 3%;
      width: 100%;
      min-width: auto;
    }
  }

  .quiz_result_correct_content {
    background: #fff;
    position: relative;
    padding: 10px 10px 0;
    border-radius: 48px 0 48px 0;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }

  @media screen and (max-width: 767px) {
    .quiz_result_correct_content {
      padding: 3% 3% 0;
    }
  }

  .quiz_result_correct_content_image {
    background: url("../assets/quiz_pop_correct-answer.png") no-repeat center;
    position: relative;
    width: 520px;
    height: 200px;
  }

  @media screen and (max-width: 767px) {
    .quiz_result_correct_content_image {
      background-size: contain;
      width: 70%;
      height: 0;
      padding-top: 28%;
    }
  }

  .quiz_correct_point_area {
    width: 384px;
    height: 52px;
    margin: 0 -10px;
    padding: 6px 258px;
    background: #ec8dae;
  }

  @media screen and (max-width: 767px) {
    .quiz_correct_point_area {
      width: 100%;
      height: auto;
      padding: 6px 10%;
      margin: 0 -5%;
    }
  }

  .quiz_correct_point_area p {
    margin: 0;
    width: 100%;
    padding: 6px 0;
    background: #fff;
    border-radius: 22px;
    text-align: center;
    color: #463e2e;
    position: relative;
  }

  .quiz_correct_point_area p span {
    font-size: 32px;
    font-weight: bold;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
  }

  @media screen and (max-width: 767px) {
    .quiz_correct_point_area p span {
      font-size: 26px;
    }
  }

  .quiz_correct_point_area p span:before {
    content: "";
    width: 40px;
    height: 40px;
    padding-right: 10px;
    bottom: -1px;
    position: relative;
    background: url("../assets/icon_point.svg") no-repeat left center;
  }

  .quiz_explain {
    padding: 38px 30px 0;
    width: 100%;
    background: #fff;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }

  @media screen and (max-width: 767px) {
    .quiz_explain {
      padding: 0 0;
    }
  }

  .quiz_result_correct_content:after {
    background: url("../assets/quiz_pop_correct-answer_deco.png") no-repeat center;
    content: "";
    width: 643px;
    height: 60px;
  }

  @media screen and (max-width: 767px) {
    .quiz_result_correct_content:after {
      background-size: contain;
      width: 100%;
      height: 0;
      padding-top: 9%;
    }
  }

  .quiz_image {
    margin: 0;
    width: 388px;
    height: 286px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  @media screen and (max-width: 767px) {
    .quiz_image {
      width: 100%;
      height: 100%;
    }
  }

  .quiz_image > img {
    width: auto;
    height: auto;
    max-width:100%;
    max-height:100%;
  }

  @media screen and (max-width: 767px) {
    .quiz_image > img {
      width: 100%;
      height: 100%;
    }
  }

  /* TODO:コンポーネント化する */
  .quiz_answer {
    width: 372px;
    margin: 44px auto;
    padding: 0 0 10px 50px;
    position: relative;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #676767;
    border-bottom: 2px solid #ec8dae;
    font-size: 18px;
    line-height: 18px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
  }

  @media screen and (max-width: 767px) {
    .quiz_answer {
      width: 100%;

    }
  }

  @media screen and (max-width: 767px) {
    .quiz_explain .quiz_answer {
      order: -1;

    }
  }

  .quiz_answer:before {
    color: #ec8dae;
    font-size: 24px;
    position: absolute;
    left: 0;
    bottom: 10px;
    content: "答え";
  }

  .quiz_answer > span {
    text-align: center;
  }

  .quiz_result {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
  }

  @media screen and (max-width: 767px) {
    .quiz_result {
      overflow: auto;
      -webkit-box-align: start;
      -webkit-align-items: flex-start;
      -ms-flex-align: start;
      align-items: start;
      padding-top: 3%;
    }
  }

  .quiz_result_bg {
    background: #000;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0.2;
  }
</style>
